import { Badge } from "@/components/ui/badge";

interface HrgPillProps {
  hrgCode: string | null | undefined;
}

const HrgPill = ({ hrgCode }: HrgPillProps) => {
  if (!hrgCode || hrgCode.trim() === "") {
    return (
      <Badge variant="outline" className="text-xs">
        No HRG
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="text-xs">
      HRG: {hrgCode}
    </Badge>
  );
};

export default HrgPill;
